@if (value?.length) {
  <div class="building-equipments"
       [sortableArray]="value"
       [sortableOptions]="sortableOptions">
    @for (be of value; track be.id) {
      <div class="building-equipment">
        <div class="building-equipment-icon"><nb-icon pack="fas" icon="cube"></nb-icon> {{be.equipment.name}} x {{be.quantity}}</div>
        <div class="address">{{be.sectionText}}</div>
        <div class="address">{{be.creatorTenant.name}}</div>
        <div>
          <button nbButton ghost (click)="navigateToBuildingEquipment(be)">
            <nb-icon pack="eva" icon="external-link-outline"></nb-icon>
          </button>
          @if (!isDisabled) {
            <button nbButton ghost (click)="removeBuildingEquipment(be)">
              <nb-icon pack="eva" icon="close"></nb-icon>
            </button>
          }
          @if (!isDisabled && be.permissions.canEdit) {
            <button nbButton ghost status="danger" (click)="deleteBuildingEquipment(be)">
              <nb-icon pack="eva" icon="trash-2-outline"></nb-icon>
            </button>
          }
        </div>
      </div>
    }
  </div>
} @else {
  <div class="text-hint">Keine TGAs ausgewählt</div>
}

@if (!isDisabled) {
  <button nbButton
          type="button"
          [nbPopover]="popoverMenu"
          [nbPopoverPlacement]="NbPosition.RIGHT">
    <nb-icon icon="plus-outline" pack="eva"></nb-icon>
  </button>
}

<ng-template #popoverMenu>
  <div class="building-equipment-add">
    <wr-list-view [items]="notSelectedBuildingEquipments$|async"
                  [searchText]="text$.value"
                  (searchTextChange)="text$.next($event)"
                  (selectedChange)="addBuildingEquipment($event)">
      <ng-template wrListItem let-item>
        <div class="building-equipment-add-item">
          <nb-icon pack="fas" icon="cube"></nb-icon>
          <div class="building-equipment-list-item-name">
            <div class="building-equipment-item-title">
              <span>{{ item.equipment.name }}</span>
              <span> x </span>
              <span>{{ item.quantity }}</span>
            </div>
            <span class="address">{{ item.sectionText }}</span>
            <span class="address">{{ item.creatorTenant.name }}</span>
          </div>
        </div>
      </ng-template>
    </wr-list-view>
  </div>
</ng-template>
